<template>
  <div v-if="responsive" class="contents">
    <JoszakiButton
      class="max-lg:hidden self-center"
      icon-left-pack="fas"
      :icon-left="icon"
      :type="type"
      :size="size"
      :expanded="expanded"
      :loading="state.loading"
      :disabled="state.requested"
      :title="state.availableAgainText"
      @click="requestCallback(source)"
    >
      {{ label }}
    </JoszakiButton>
    <JoszakiButton
      class="lg:hidden self-center"
      icon-left-pack="fas"
      :icon-left="icon"
      :type="type"
      :size="size"
      :title="state.availableAgainText || label"
      :loading="state.loading"
      :disabled="state.requested"
      @click="requestCallback(source)"
    />
  </div>
  <JoszakiButton
    v-else
    icon-left-pack="fas"
    :icon-left="icon"
    :type="type"
    :size="size"
    :expanded="expanded"
    :loading="state.loading"
    :disabled="state.requested"
    :title="state.availableAgainText"
    @click="requestCallback(source)"
  >
    {{ label }}
  </JoszakiButton>
</template>

<script>
import { computed, useContext } from "@nuxtjs/composition-api";
import { useRequestCallback } from "~/composables/useRequestCallback";

export default {
  name: "RequestCallbackButton",
  props: {
    source: {
      type: String,
      required: true,
    },
    responsive: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "warning",
    },
    size: {
      type: String,
      default: "md",
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { i18n } = useContext();
    const { state, requestCallback } = useRequestCallback();

    const icon = computed(() => (state.requested ? "check" : "phone"));
    const label = computed(() =>
      i18n.t(
        state.requested ? "requestCallback.requested" : "requestCallback.button"
      )
    );

    return {
      state,
      requestCallback,
      icon,
      label,
    };
  },
};
</script>
